// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchBox_root__sFsQk","field":"SearchBox_field__16b-Z"};